import React from "react";
import { motion } from "framer-motion";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import ContactForm from "components/forms/ContactForm";

const Contact = () => {
  return (
    <div className="min-h-screen bg-complementary-light py-12 sm:py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
      >
        {/* Header */}
        <div className="mb-16 text-center">
          <h1 className="text-4xl font-bold text-nature-green-dark sm:text-5xl">
            Get In Touch
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            We'd love to hear from you. Please fill out the form below or
            contact us directly.
          </p>
        </div>

        <div className="grid grid-cols-1 items-start gap-16 lg:grid-cols-2">
          {/* Contact Information */}
          <div className="rounded-lg bg-white p-8 shadow-md sm:p-10">
            <h2 className="mb-8 text-3xl font-bold text-nature-green-dark">
              Contact Information
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <FiMail className="mr-4 mt-1 text-2xl text-nature-green" />
                <div>
                  <h3 className="text-xl font-semibold">Email</h3>
                  <a
                    href="mailto:admin@example.com"
                    className="text-gray-600 transition-colors hover:text-nature-green"
                  >
                    admin@example.com
                  </a>
                  <p className="text-sm text-gray-500">For general inquiries</p>
                </div>
              </div>
              <div className="flex items-start">
                <FiPhone className="mr-4 mt-1 text-2xl text-nature-green" />
                <div>
                  <h3 className="text-xl font-semibold">Phone</h3>
                  <a
                    href="tel:+1234567890"
                    className="text-gray-600 transition-colors hover:text-nature-green"
                  >
                    +1 (234) 567-890
                  </a>
                  <p className="text-sm text-gray-500">Mon-Fri, 9am-5pm</p>
                </div>
              </div>
              <div className="flex items-start">
                <FiMapPin className="mr-4 mt-1 text-2xl text-nature-green" />
                <div>
                  <h3 className="text-xl font-semibold">Office</h3>
                  <p className="text-gray-600">123 Nature Lane, Green Valley</p>
                  <p className="text-sm text-gray-500">
                    Visits by appointment only
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <ContactForm />
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
